import React, { useEffect, useState } from 'react'
import SimpleTable from '@modul-connect/shared/components/molecules/tableWidget/simpleTable'
import theme from '../../../theme'
import { Box } from '@mui/material'

export const TabbedSimpleTable = ({ tabs = [], defaultTab = 0 }) => {
  
  const idx = tabs.findIndex(t => (t.data ?? []).length > 0)
  const firstTabWithData = idx === -1 ? defaultTab : idx

  const [tabIndex, setTabIndex] = useState(firstTabWithData)

  useEffect(() => {
    if (!tabs.length) return
    setTabIndex(firstTabWithData)
  }, [firstTabWithData, tabs.length])

  if (!tabs.length) return null

  const active = tabs[tabIndex]

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          height: 42,
          background: theme.colors.barBackground,
          borderTop: `1px solid ${theme.colors.borderGreyTabs}`,
        }}
      >
        {tabs.map((t, i) => {
          const isActive = i === tabIndex
          return (
            <Box
              key={t.id}
              onClick={() => setTabIndex(i)}
              sx={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                background: isActive ? '#fff' : 'transparent',
                borderRight: i !== tabs.length - 1 ? `1px solid ${theme.colors.borderGreyTabs}` : 'none',
                borderBottom: isActive ? 'none' : `1px solid ${theme.colors.borderGreyTabs}`,
                fontSize: 14,
                fontWeight: isActive ? 700 : 400,
                color: theme.colors.iconBlack,
                gap: 6,
              }}
            >
              {t.label}
            </Box>
          )
        })}
      </Box>
      <Box>
        <SimpleTable
          data={active.data}
          columns={active.columns}
          tableTitle={active.tableTitle}
          totalItems={active.data?.length}
          noDataText={active.noDataText}
        />
      </Box>
    </Box>
  )
}